import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
} from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationService } from './services/navigation.service';
import { ResizeService } from './services/resize.service';
import { AuthService } from './services/auth.service';
import { TranslateService } from './services/translate.service';
import { BREAKPOINT_MD } from './constants/constants';
import { ROUTES } from './constants/routes';
import { LocalStorageService } from './services/local-storage.service';
import { CookiesService } from './services/cookies.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private innerWidth: number = window.innerWidth;
  public currentRouteUrl$: Observable<string | null> =
    this.navigation.getCurrentRoute$();
  public canUseFacebookPixel$ = this.cookiesService.canUseCookies$;

  @HostListener('window:resize')
  onResize(): void {
    this.innerWidth = window.innerWidth;
  }

  constructor(
    private authService: AuthService, // Used for loading the user before any other request
    private navigation: NavigationService,
    private resize: ResizeService,
    private translateService: TranslateService,
    private localStorage: LocalStorageService,
    private cookiesService: CookiesService
  ) {
    this.translateService.translationsChanged$.subscribe(() => {
      window.location.reload();
    });
  }

  isOnLoginPage(currentRoute: string): boolean {
    return currentRoute.includes('auth');
  }

  isSolidHeader(currentRouteUrl: string): boolean {
    if (this.isOnLoginPage(currentRouteUrl)) {
      return this.innerWidth < BREAKPOINT_MD;
    }

    return !this.isOnLandingPage(currentRouteUrl);
  }

  isCms(currentRoute: string): boolean {
    return currentRoute.includes('cms');
  }

  showMainHeader(currentRoute: string): boolean {
    return !this.isCms(currentRoute);
  }

  showCmsNavigation(currentRoute: string): boolean {
    return this.isCms(currentRoute);
  }

  isFullWidth(currentRoute: string): boolean {
    return this.isCms(currentRoute) || currentRoute.includes(ROUTES.MY_ACCOUNT);
  }

  isOnLandingPage(currentRoute: string): boolean {
    return currentRoute === '/';
  }

  handleResizeEvent(width: number): void {
    this.resize.setWith(width);
  }

  get showCookiesConsent(): boolean {
    return this.localStorage.getInfo().canUseCookies === undefined;
  }
}
